import { render, staticRenderFns } from "./bulma_table.vue?vue&type=template&id=77273ecc&scoped=true&lang=html"
import script from "./bulma_table.vue?vue&type=script&lang=js"
export * from "./bulma_table.vue?vue&type=script&lang=js"
import style0 from "./bulma_table.vue?vue&type=style&index=0&id=77273ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77273ecc",
  null
  
)

export default component.exports